import { Avatar } from '@mui/material';

export interface EntityLogoProps {
  photoURL?: string | null;
  shape: 'circle' | 'square';
}

const EntityLogo = ({ photoURL, shape }: EntityLogoProps) => {
  if (shape === 'square') {
    return (
      <img
        src={photoURL ?? undefined}
        alt='Logo'
        style={{
          backgroundColor: 'background.paper',
          color: 'text.secondary',
          maxWidth: '400px',
          maxHeight: '150px',
          margin: '10px',
        }}
      />
    );
  }
  return (
    <Avatar
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.secondary',
        width: '150px',
        height: '150px',
        margin: '10px',
      }}
      src={photoURL ?? undefined}
    ></Avatar>
  );
};

export default EntityLogo;
